import { InputForm, SelectForm, SubmitButton } from "components";
import { useEffect, useState } from "react";
import { CloudUploadIcon } from "assets";
import { CheyCheyImageType } from "props/enum";

export interface AvatarInput {
    image: string;
    type: string;
    title: string;
    category:string;

}

export interface avatarImageError {
    image?: string;
    type?: string;
    title?: string;
    category?: string;
}
interface BaseFormProps {
    loading: boolean;
    header: string;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
}

interface GroupFormProps extends BaseFormProps {
    formData: AvatarInput;
    error?: avatarImageError | null;
    handleImageFileChange?: (file: File) => void;
}

export const UploadAvatar: React.FC<GroupFormProps> = ({
    formData,
    handleChange,
    handleSubmit,
    error,
    loading,
    header,
    handleImageFileChange,
}) => {
    const [imagePreviewUrl, setImagePreviewUrl] = useState<string | "">("");
    useEffect(() => {
        if (formData?.image) {
            setImagePreviewUrl(formData.image);
        }
    }, [formData?.image]);
    return (
        <form>
            <InputForm
              label="Title"
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
            <InputForm
              label="Category"
              type="text"
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            />
            {/* {formError?.title && <Error>{formError.}</Error>} */}
            <SelectForm
                label="Image Type"
                id="type"
                name="type"
                value={formData.type}
                option={Object.values(CheyCheyImageType).map((type) => (
                    <option key={type} value={type}>{type}</option>
                ))
                }
                onChange={handleChange}
            />
            <div className="mb-4">
                <label
                    htmlFor="dropzone-thumbnail"
                    onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const file = e.dataTransfer.files?.[0];
                        if (file) {
                            setImagePreviewUrl(URL.createObjectURL(file));
                            if (handleImageFileChange) handleImageFileChange(file);
                        }
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    className="relative flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                >
                    {imagePreviewUrl.length > 0 ? (
                        <>
                            <img
                                src={imagePreviewUrl || ""}
                                alt="Avatar Preview"
                                className="absolute inset-0 w-full h-full object-cover rounded-lg opacity-70"
                            />
                            <div className="z-10 flex flex-col items-center justify-center">
                                <CloudUploadIcon />
                                <p className="mb-2 text-sm text-white">
                                    <span className="font-semibold">Click to upload</span> or drag and drop
                                </p>
                                <p className="text-xs text-white">JPG, PNG, WebP formats</p>
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <CloudUploadIcon />
                            <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold">Click to upload</span> or drag and drop
                            </p>
                            <p className="text-xs text-gray-500">JPG, PNG, WebP formats</p>
                        </div>
                    )}
                    <input
                        id="dropzone-thumbnail"
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) {
                                setImagePreviewUrl(URL.createObjectURL(file));
                                if (handleImageFileChange) handleImageFileChange(file);
                            }
                        }}
                    />
                </label>
            </div>
            <SubmitButton loading={loading} onClick={handleSubmit} />
        </form>
    );
};


